module.exports = __webpack_public_path__ + "media/images/img_support03-d63343d99dc5a6a6eb10be87bb3de148.jpg";